import React from 'react';
import {MessageSquareText, ChevronRight} from "lucide-react";
import botIcon from "../../assets/iconChat.png"

const Welcome = ({openChat, brandName = "RMT-AI"}: { openChat: () => void; brandName?: string }) => {
    return (
        <div className="welcome">
            <div className="welcome-icon">
                <img src={botIcon} alt="RMT AI Chatbot" />
            </div>
            <div className="text-center">
                <h5 className={'title'}>Welcome to {brandName}</h5>
                <h6 className={'subtitle'}>How can we help you today?</h6>
            </div>
            <div className="welcome-actions">
                <button
                    className="d-flex align-items-center justify-content-between px-3 btna"
                    onClick={openChat}
                >
                    <div className={'d-flex flex-row align-items-center gap-3'}>
                        <div className="btn-icon chat-icon">
                            <MessageSquareText size={18} />
                        </div>
                        <span>Discuss with us</span>
                    </div>
                    <ChevronRight size={18} className="chevron"/>
                </button>
            </div>
        </div>
    );
};

export default Welcome;
